export const switchFunctionCategory = (category) => (
  (dispatch) => {
    dispatch({
      type: 'SWITCH_FUNCTION_CATEGORY',
      payload: category
    });
  }
);

export const forwardToToggleMenu = (tggle) => {
  let ret = (dispatch) => {
    dispatch({
      type: 'TOGGLE_MENU',
      payload: null,
    });
  }
  return ret;
};

// 切換是否隱藏menu和bar
export const forwardToExpandMenuMax = () => {
  let ret = (dispatch) => {
    dispatch({
      type: 'MENU_EXPAND_MAX',
      payload: null,
    });
  }
  return ret;
};


// WEBPACK FOOTER //
// ./src/actions/menuActions.js